import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import darkTheme from '../../src/theme';
import Image from "next/image";
import Skeleton from "@mui/material/Skeleton";

const eventImage = {    
    marginTop: darkTheme.spacing(2),
    marginBottom: darkTheme.spacing(2),
    '& img': {
        borderRadius: 3,
        minWidth: '100%',
    },
    [darkTheme.breakpoints.down("md")]: {
        position: 'relative !important',
        top: `0 !important`,
        marginTop: darkTheme.spacing(0),
        marginBottom: darkTheme.spacing(2),        
    }
};


function Terms({ data }) {   
    const [loading, setLoading] = useState(true);
    const [content, setContent] = useState(data ? data : null);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    useEffect(() => {
        setContent(data ? data : null)
        setLoading(false)
    },[data])

  return (
      <>      
          {!loading ? (                    
              <Typography component="div"
                  sx={eventImage}
                  style={{
                      position: "sticky",
                      top: "16%",
                  }}
              >
                  <Image
                      src={content.img_path ? content.img_path : 'https://clubrstorage.blob.core.windows.net/clubr-img/default.jpg'}
                      alt="..."
                      style={{ maxWidth: "100%" }}
                      height={100}
                      width={100}
                      layout='responsive'
                      priority
                  />
                
              </Typography>
          ) : (
            <Skeleton
                animation="wave"
                variant="rectangular"
                height={500}
                sx={{ borderRadius: darkTheme.spacing(1), color: "grey.900", marginTop: darkTheme.spacing(3) }}                
            />                  
          )}
    </>
  );
}

export default Terms;
